import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dismissOrder, cancelDelivery, setCurrentOrder } from '@app/actions/orders';
import { getFilteredNewOrders, getNewOrders } from '@app/reducer/orders';
import IncomingOrdersSection from './IncomingOrdersSection';

const mapStateToProps = state => {
  const {
    auth: { chamaID },
  } = state;
  const order = state.orders.dict[state.orders.currentOrderId];
  const dealers = state.dealer.all;
  const {
    time: { offset },
  } = state;

  const filteredNewOrders = getFilteredNewOrders(state);
  const allNewOrders = getNewOrders(state);

  return {
    dealers,
    filteredNewOrders,
    allNewOrders,
    activeOrder: order,
    offset,
    userId: chamaID,
  };
};

const mapDispatchToProps = {
  dismissOrder,
  cancelDelivery,
  setCurrentOrder,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IncomingOrdersSection));



// WEBPACK FOOTER //
// ./src/modules/orders/components/IncomingOrdersSection/IncomingOrdersSection.connect.jsx